import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import MenuIcon from '@mui/icons-material/Menu';
import List from '@mui/material/List';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { useSelector } from "react-redux";
import DrawerItem from './DrawerItem';
import SupportAgentIcon from "@mui/icons-material/SupportAgent";


const drawerWidth = 240;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default function CustomDrawer({ open, handleDrawerClose, navigate }) {
  const userType = useSelector((state) => state.auth.userType);
  return (
    <Drawer variant="permanent" open={open}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              <MenuIcon />
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {userType === 'ADMIN' || userType === 'OPERATION' ? <DrawerItem text="Operation" icon={<SupportAgentIcon />} navigate={() => navigate('/Operation')} open={open} /> : <></>}
          </List>
          <Divider />
          <List>
            {userType === 'ADMIN' || userType === 'FINANCE' ? <DrawerItem text="FINANCE" icon={<AccountBalanceIcon />} navigate={() => navigate("/Finance")} open={open} /> : <></>}
          </List>
        </Box>


      </Box>
    </Drawer>
  );
}
